(function($) {

/*
*  new_map
*
*  This function will render a Google Map onto the selected jQuery element
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$el (jQuery element)
*  @return	n/a
*/


styles = [
  {
    "stylers": [
      {
        "hue": "#ff0000"
      },
      {
        "visibility": "on"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "color": "#808080"
      }
    ]
  },
  {
    "elementType": "labels.text",
    "stylers": [
      {
        "color": "#808080"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#808080"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#808080"
      }
    ]
  },
  {
    "featureType": "administrative",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#444444"
      }
    ]
  },
  {
    "featureType": "administrative.country",
    "stylers": [
      {
        "color": "#890f0f"
      },
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.country",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "administrative.country",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#ff0000"
      },
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "landscape",
    "stylers": [
      {
        "color": "#f2f2f2"
      },
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road",
    "stylers": [
      {
        "saturation": -100
      },
      {
        "lightness": 45
      },
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "stylers": [
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "transit",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "water",
    "stylers": [
      {
        "color": "#bb9b81"
      },
      {
        "visibility": "on"
      }
    ]
  }
];
function new_map( $el, styles ) {
	
	// var
	var $markers = $el.find('.marker');
	
	
	// vars
	var args = {
		zoom		: 14,
		center		: new google.maps.LatLng(0, 0),
		mapTypeId	: google.maps.MapTypeId.ROADMAP,
		styles 		: styles,
        scrollwheel: false,
		mapTypeControl : false,
		scaleControl: false,
		streetViewControl: false,
		rotateControl: false,
		fullscreenControl: false
	};
	
	
	// create map	        	
	var map = new google.maps.Map( $el[0], args);
	
	
	// add a markers reference
	map.markers = [];
	
	
	// add markers
	$markers.each(function(){
		
    	add_marker( $(this), map );
		
	});
	
	
	// center map
	center_map( map );
	
	
	// return
	return map;
	
}



/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$marker (jQuery element)
*  @param	map (Google Map object)
*  @return	n/a
*/

function add_marker( $marker, map ) {

	// var
	var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );



	// create marker
	var marker = new google.maps.Marker({
		position	: latlng,
		map			: map,
    label       : {
                    text: $marker.attr('data-nb-projects'),
                    color: 'white',
                },
		project 	: $marker.attr('data-project'),
		slide 		: $marker.attr('data-slide'),
        dataNbProjects : $marker.attr('data-nb-projects'),
		icon: {
            // Adresse de l'icône personnalisée
            url: dir_img+'picto-off-number.png',
            // Taille de l'icône personnalisée
            size: new google.maps.Size(68, 69),
            // Origine de l'image, souvent (0, 0)
            origin: new google.maps.Point(0,0),
            // L'ancre de l'image. Correspond au point de l'image que l'on raccroche à la carte. Par exemple, si votre îcone est un drapeau, cela correspond à son mâts
            anchor: new google.maps.Point(34, 35)
        },
	});
	// add to array
	map.markers.push( marker );

	if( $marker.html() )
	{
		// create info window
		var infowindow = new google.maps.InfoWindow({
			content		: '<div class="infowindow">'+$marker.html()+'</div>'
		});

		// show info window when marker is clicked
		/*google.maps.event.addListener(marker, 'click', function() {

			infowindow.open( map, marker );

		});*/
	}



	google.maps.event.addListener(marker, 'click', function() {

		for (var j = 0; j < map.markers.length; j++) {
	    	map.markers[j].setIcon({
              // Adresse de l'icône personnalisée
              url: dir_img+'picto-off-number.png',
              // Taille de l'icône personnalisée
              size: new google.maps.Size(68, 69),
              // Origine de l'image, souvent (0, 0)
              origin: new google.maps.Point(0,0),
              // L'ancre de l'image. Correspond au point de l'image que l'on raccroche à la carte. Par exemple, si votre îcone est un drapeau, cela correspond à son mâts
              anchor: new google.maps.Point(34, 35)
          });
            map.markers[j].setLabel({
                        text:  map.markers[j].dataNbProjects,
                        color: 'white',
                        fontSize:'14px',
                        fontWeight:'normal',
                    });
	    }
        
		marker.setIcon({
        // Adresse de l'icône personnalisée
        url: dir_img+'picto-on.png',
        // Taille de l'icône personnalisée
        size: new google.maps.Size(94, 77),
        // Origine de l'image, souvent (0, 0)
        origin: new google.maps.Point(0,0),
        // L'ancre de l'image. Correspond au point de l'image que l'on raccroche à la carte. Par exemple, si votre îcone est un drapeau, cela correspond à son mâts
        anchor: new google.maps.Point(47,38)
    });
        marker.setLabel({
                    text: $marker.attr('data-nb-projects'),
                    color: '#404041',
                    fontSize:'24px',
                    fontWeight:'bold',
                });

        $('#map-section .projets').animate({
            scrollTop: 0
        }, 500);
        $('#map-section .project:not(.'+marker.project+')').hide();
        $('#map-section .'+marker.project).show();

        

        /*count = $('.project:not(.'+marker.project+')').length;

        $.each($('.project:not(.'+marker.project+')'), function(i, el){
            setTimeout(function(){
               $(el).hide('blind',{}, 400);
            },400 + ( i * 400 ));
            if(! --count){
                $.each($('.'+marker.project), function(ishow, elshow){
                    setTimeout(function(){
                       $(elshow).show('blind',{}, 400);
                    },400 + ( ishow * 400 ));

                })
            }
        });*/

	});

}

/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	map (Google Map object)
*  @return	n/a
*/

function center_map( map ) {

	// vars
	var bounds = new google.maps.LatLngBounds();

	// loop through all markers and create bounds
	$.each( map.markers, function( i, marker ){

		var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

		bounds.extend( latlng );

	});

	// only 1 marker?
	if( map.markers.length == 1 )
	{
		// set center of map
	    map.setCenter( bounds.getCenter() );
	    map.setZoom( 14 );
	}
	else
	{
		// fit to bounds
		map.fitBounds( bounds );
	}

}



/*
*  document ready
*
*  This function will render each map when the document is ready (page has loaded)
*
*  @type	function
*  @date	8/11/2013
*  @since	5.0.0
*
*  @param	n/a
*  @return	n/a
*/
// global var
var map = null;

$(document).ready(function(){

	$('.acf-map').each(function(){
		
		// create map
		map = new_map( $(this), styles );
    
	});

    $('#init-map').on('click', function(){
        $('.project').show();
        map.setZoom( 2 );
        for (var j = 0; j < map.markers.length; j++) {
            map.markers[j].setIcon({
                  // Adresse de l'icône personnalisée
                  url: dir_img+'picto-off-number.png',
                  // Taille de l'icône personnalisée
                  size: new google.maps.Size(68, 69),
                  // Origine de l'image, souvent (0, 0)
                  origin: new google.maps.Point(0,0),
                  // L'ancre de l'image. Correspond au point de l'image que l'on raccroche à la carte. Par exemple, si votre îcone est un drapeau, cela correspond à son mâts
                  anchor: new google.maps.Point(34, 35)
              });
             map.markers[j].setLabel({
                        text:  map.markers[j].dataNbProjects,
                        color: 'white',
                        fontSize:'14px',
                        fontWeight:'normal',
                    });
        }
    })

}); 

})(jQuery); 